import { useLocation } from 'react-router';

export const useRedirectUrl = () => {
    const location = useLocation();

    const getRedirectUrl = () => {
        const query = new URLSearchParams(location.search);
        const returnUrl = query.get('returnUrl');
        return returnUrl ? `/${returnUrl}` : '/dashboard';
    };

    return { getRedirectUrl };
};
